window.addEventListener("load", (e) => {
  let birthday2El = document.getElementById("jsBirthday2");
  if (birthday2El) {
    $("#jsBirthday2").select2({
      placeholder: "Năm sinh",
    });
  }

  let birthday1El = document.getElementById("jsBirthday1");
  if (birthday1El) {
    $("#jsBirthday1").select2({
      placeholder: "Năm sinh",
    });
  }

  let education1El = document.getElementById("jsEducation1");
  if (education1El) {
    $("#jsEducation1").select2({
      placeholder: "Chương trình đào tạo",
    });
  }

  let education2El = document.getElementById("jsEducation2");
  if (education2El) {
    $("#jsEducation2").select2({
      placeholder: "Chương trình đào tạo",
    });
  }

  let level1El = document.getElementById("jsLevel1");
  if (level1El) {
    $("#jsLevel1").select2({
      placeholder: "Trình độ học vấn",
    });
  }

  let level2El = document.getElementById("jsLevel2");
  if (level2El) {
    $("#jsLevel2").select2({
      placeholder: "Trình độ học vấn",
    });
  }
});
